import { createContext } from 'react';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';
import utils from 'utils';

type DataRoomContextValues = {
  displayedQuestions: Question[];
  totalPages: number;
  areQuestionsLoading: boolean;
  setQuestionsLoading: (v: boolean) => void;
  openFAQ: () => void;
  openForEdit: (Question: Question) => void;
  setDisplayedQuestions: React.Dispatch<React.SetStateAction<Question[]>>;
  updateQuestion: (question: Partial<Question>) => void;
};

export default createContext<DataRoomContextValues>({
  displayedQuestions: [],
  totalPages: 1,
  areQuestionsLoading: true,
  setQuestionsLoading: utils.noop,
  openFAQ: utils.noop,
  openForEdit: utils.noop,
  setDisplayedQuestions: utils.noop,
  updateQuestion: utils.noop,
});
